// GENERERAD FIL — ändra inte för hand.
// Kör: bun run gen:clusters
//
// Stadskluster: /filmproduktion/{stad} är primär sida per ort.
// Priskluster: /fragor/vad-kostar-{tjänst} är primär sida per pristjänst.
// Manuella undantag i canonical-overrides.ts har högre prioritet.

export const CLUSTER_PRIMARY: Record<string, string> = {
  "/employer-branding-film/boras": "/filmproduktion/boras",
  "/employer-branding-film/eskilstuna": "/filmproduktion/eskilstuna",
  "/employer-branding-film/gavle": "/filmproduktion/gavle",
  "/employer-branding-film/halmstad": "/filmproduktion/halmstad",
  "/employer-branding-film/helsingborg": "/filmproduktion/helsingborg",
  "/employer-branding-film/jonkoping": "/filmproduktion/jonkoping",
  "/employer-branding-film/karlstad": "/filmproduktion/karlstad",
  "/employer-branding-film/linkoping": "/filmproduktion/linkoping",
  "/employer-branding-film/lulea": "/filmproduktion/lulea",
  "/employer-branding-film/lund": "/filmproduktion/lund",
  "/employer-branding-film/norrkoping": "/filmproduktion/norrkoping",
  "/employer-branding-film/orebro": "/filmproduktion/orebro",
  "/employer-branding-film/solna": "/filmproduktion/solna",
  "/employer-branding-film/sundsvall": "/filmproduktion/sundsvall",
  "/employer-branding-film/umea": "/filmproduktion/umea",
  "/employer-branding-film/uppsala": "/filmproduktion/uppsala",
  "/employer-branding-film/vasteras": "/filmproduktion/vasteras",
  "/employer-branding-film/vaxjo": "/filmproduktion/vaxjo",
  "/filmbyra/boras": "/filmproduktion/boras",
  "/filmbyra/borlange": "/filmproduktion/borlange",
  "/filmbyra/eskilstuna": "/filmproduktion/eskilstuna",
  "/filmbyra/falun": "/filmproduktion/falun",
  "/filmbyra/gavle": "/filmproduktion/gavle",
  "/filmbyra/goteborg": "/filmproduktion/goteborg",
  "/filmbyra/halmstad": "/filmproduktion/halmstad",
  "/filmbyra/helsingborg": "/filmproduktion/helsingborg",
  "/filmbyra/hisingen": "/filmproduktion/hisingen",
  "/filmbyra/hyllie": "/filmproduktion/hyllie",
  "/filmbyra/jonkoping": "/filmproduktion/jonkoping",
  "/filmbyra/kalmar": "/filmproduktion/kalmar",
  "/filmbyra/karlskrona": "/filmproduktion/karlskrona",
  "/filmbyra/karlstad": "/filmproduktion/karlstad",
  "/filmbyra/kista": "/filmproduktion/kista",
  "/filmbyra/kristianstad": "/filmproduktion/kristianstad",
  "/filmbyra/lindholmen": "/filmproduktion/lindholmen",
  "/filmbyra/linkoping": "/filmproduktion/linkoping",
  "/filmbyra/lulea": "/filmproduktion/lulea",
  "/filmbyra/lund": "/filmproduktion/lund",
  "/filmbyra/malmo": "/filmproduktion/malmo",
  "/filmbyra/molndal": "/filmproduktion/molndal",
  "/filmbyra/nacka": "/filmproduktion/nacka",
  "/filmbyra/norrkoping": "/filmproduktion/norrkoping",
  "/filmbyra/nykoping": "/filmproduktion/nykoping",
  "/filmbyra/orebro": "/filmproduktion/orebro",
  "/filmbyra/ostersund": "/filmproduktion/ostersund",
  "/filmbyra/skelleftea": "/filmproduktion/skelleftea",
  "/filmbyra/skovde": "/filmproduktion/skovde",
  "/filmbyra/sodermalm": "/filmproduktion/sodermalm",
  "/filmbyra/sodertalje": "/filmproduktion/sodertalje",
  "/filmbyra/solna": "/filmproduktion/solna",
  "/filmbyra/stockholm": "/filmproduktion/stockholm",
  "/filmbyra/sundbyberg": "/filmproduktion/sundbyberg",
  "/filmbyra/sundsvall": "/filmproduktion/sundsvall",
  "/filmbyra/taby": "/filmproduktion/taby",
  "/filmbyra/trollhattan": "/filmproduktion/trollhattan",
  "/filmbyra/uddevalla": "/filmproduktion/uddevalla",
  "/filmbyra/umea": "/filmproduktion/umea",
  "/filmbyra/uppsala": "/filmproduktion/uppsala",
  "/filmbyra/varberg": "/filmproduktion/varberg",
  "/filmbyra/vasteras": "/filmproduktion/vasteras",
  "/filmbyra/vaxjo": "/filmproduktion/vaxjo",
  "/filmbyra/visby": "/filmproduktion/visby",
  "/foretagsfilm/boras": "/filmproduktion/boras",
  "/foretagsfilm/eskilstuna": "/filmproduktion/eskilstuna",
  "/foretagsfilm/gavle": "/filmproduktion/gavle",
  "/foretagsfilm/goteborg": "/filmproduktion/goteborg",
  "/foretagsfilm/helsingborg": "/filmproduktion/helsingborg",
  "/foretagsfilm/jonkoping": "/filmproduktion/jonkoping",
  "/foretagsfilm/karlstad": "/filmproduktion/karlstad",
  "/foretagsfilm/linkoping": "/filmproduktion/linkoping",
  "/foretagsfilm/lulea": "/filmproduktion/lulea",
  "/foretagsfilm/lund": "/filmproduktion/lund",
  "/foretagsfilm/norrkoping": "/filmproduktion/norrkoping",
  "/foretagsfilm/orebro": "/filmproduktion/orebro",
  "/foretagsfilm/solna": "/filmproduktion/solna",
  "/foretagsfilm/stockholm": "/filmproduktion/stockholm",
  "/foretagsfilm/sundsvall": "/filmproduktion/sundsvall",
  "/foretagsfilm/umea": "/filmproduktion/umea",
  "/foretagsfilm/uppsala": "/filmproduktion/uppsala",
  "/foretagsfilm/vasteras": "/filmproduktion/vasteras",
  "/foretagsfilm/vaxjo": "/filmproduktion/vaxjo",
  "/pris/employer-branding-film": "/fragor/vad-kostar-employer-branding-film",
  "/pris/filmabonnemang": "/fragor/vad-kostar-film-pa-abonnemang",
  "/pris/filmproduktion": "/fragor/vad-kostar-filmproduktion",
  "/pris/livsberattelse-film": "/fragor/vad-kostar-livsberattelse-pa-film",
  "/pris/minnesfilm": "/fragor/vad-kostar-minnesfilm",
  "/pris/produktfilm": "/fragor/vad-kostar-produktfilm",
  "/pris/videoproduktion": "/fragor/vad-kostar-videoproduktion",
  "/produktionsbolag/boras": "/filmproduktion/boras",
  "/produktionsbolag/eskilstuna": "/filmproduktion/eskilstuna",
  "/produktionsbolag/gavle": "/filmproduktion/gavle",
  "/produktionsbolag/goteborg": "/filmproduktion/goteborg",
  "/produktionsbolag/halmstad": "/filmproduktion/halmstad",
  "/produktionsbolag/helsingborg": "/filmproduktion/helsingborg",
  "/produktionsbolag/jonkoping": "/filmproduktion/jonkoping",
  "/produktionsbolag/karlstad": "/filmproduktion/karlstad",
  "/produktionsbolag/linkoping": "/filmproduktion/linkoping",
  "/produktionsbolag/lulea": "/filmproduktion/lulea",
  "/produktionsbolag/lund": "/filmproduktion/lund",
  "/produktionsbolag/malmo": "/filmproduktion/malmo",
  "/produktionsbolag/norrkoping": "/filmproduktion/norrkoping",
  "/produktionsbolag/orebro": "/filmproduktion/orebro",
  "/produktionsbolag/solna": "/filmproduktion/solna",
  "/produktionsbolag/sundsvall": "/filmproduktion/sundsvall",
  "/produktionsbolag/umea": "/filmproduktion/umea",
  "/produktionsbolag/uppsala": "/filmproduktion/uppsala",
  "/produktionsbolag/vasteras": "/filmproduktion/vasteras",
  "/produktionsbolag/vaxjo": "/filmproduktion/vaxjo",
  "/reklamfilm/boras": "/filmproduktion/boras",
  "/reklamfilm/eskilstuna": "/filmproduktion/eskilstuna",
  "/reklamfilm/gavle": "/filmproduktion/gavle",
  "/reklamfilm/halmstad": "/filmproduktion/halmstad",
  "/reklamfilm/helsingborg": "/filmproduktion/helsingborg",
  "/reklamfilm/jonkoping": "/filmproduktion/jonkoping",
  "/reklamfilm/karlstad": "/filmproduktion/karlstad",
  "/reklamfilm/linkoping": "/filmproduktion/linkoping",
  "/reklamfilm/lulea": "/filmproduktion/lulea",
  "/reklamfilm/lund": "/filmproduktion/lund",
  "/reklamfilm/norrkoping": "/filmproduktion/norrkoping",
  "/reklamfilm/orebro": "/filmproduktion/orebro",
  "/reklamfilm/solna": "/filmproduktion/solna",
  "/reklamfilm/sundsvall": "/filmproduktion/sundsvall",
  "/reklamfilm/umea": "/filmproduktion/umea",
  "/reklamfilm/uppsala": "/filmproduktion/uppsala",
  "/reklamfilm/vasteras": "/filmproduktion/vasteras",
  "/reklamfilm/vaxjo": "/filmproduktion/vaxjo",
  "/videobyra/boras": "/filmproduktion/boras",
  "/videobyra/eskilstuna": "/filmproduktion/eskilstuna",
  "/videobyra/gavle": "/filmproduktion/gavle",
  "/videobyra/goteborg": "/filmproduktion/goteborg",
  "/videobyra/halmstad": "/filmproduktion/halmstad",
  "/videobyra/helsingborg": "/filmproduktion/helsingborg",
  "/videobyra/jonkoping": "/filmproduktion/jonkoping",
  "/videobyra/karlstad": "/filmproduktion/karlstad",
  "/videobyra/linkoping": "/filmproduktion/linkoping",
  "/videobyra/lulea": "/filmproduktion/lulea",
  "/videobyra/lund": "/filmproduktion/lund",
  "/videobyra/malmo": "/filmproduktion/malmo",
  "/videobyra/norrkoping": "/filmproduktion/norrkoping",
  "/videobyra/orebro": "/filmproduktion/orebro",
  "/videobyra/solna": "/filmproduktion/solna",
  "/videobyra/stockholm": "/filmproduktion/stockholm",
  "/videobyra/sundsvall": "/filmproduktion/sundsvall",
  "/videobyra/umea": "/filmproduktion/umea",
  "/videobyra/uppsala": "/filmproduktion/uppsala",
  "/videobyra/vasteras": "/filmproduktion/vasteras",
  "/videobyra/vaxjo": "/filmproduktion/vaxjo",
  "/videoproduktion/boras": "/filmproduktion/boras",
  "/videoproduktion/eskilstuna": "/filmproduktion/eskilstuna",
  "/videoproduktion/gavle": "/filmproduktion/gavle",
  "/videoproduktion/goteborg": "/filmproduktion/goteborg",
  "/videoproduktion/halmstad": "/filmproduktion/halmstad",
  "/videoproduktion/helsingborg": "/filmproduktion/helsingborg",
  "/videoproduktion/jonkoping": "/filmproduktion/jonkoping",
  "/videoproduktion/karlstad": "/filmproduktion/karlstad",
  "/videoproduktion/linkoping": "/filmproduktion/linkoping",
  "/videoproduktion/lulea": "/filmproduktion/lulea",
  "/videoproduktion/lund": "/filmproduktion/lund",
  "/videoproduktion/malmo": "/filmproduktion/malmo",
  "/videoproduktion/norrkoping": "/filmproduktion/norrkoping",
  "/videoproduktion/orebro": "/filmproduktion/orebro",
  "/videoproduktion/solna": "/filmproduktion/solna",
  "/videoproduktion/stockholm": "/filmproduktion/stockholm",
  "/videoproduktion/sundsvall": "/filmproduktion/sundsvall",
  "/videoproduktion/umea": "/filmproduktion/umea",
  "/videoproduktion/uppsala": "/filmproduktion/uppsala",
  "/videoproduktion/vasteras": "/filmproduktion/vasteras",
  "/videoproduktion/vaxjo": "/filmproduktion/vaxjo",
};
